import { Action } from "./actions"
import { ParentState } from "./state"

import { combineEpics, Epic } from "redux-observable"

const epic: Epic<Action, Action, ParentState> = combineEpics()
export default epic
